import { createAsyncThunk } from '@reduxjs/toolkit';
import getApiClient from 'js/apiClient';
import {
    IUser,
    ILoginForm,
    IUserScore,
    IScoreType,
    INewUserScore,
} from './types';

export const asyncFetchSessionUser = createAsyncThunk<IUser, void>(
    'users/fetchSessionUser',
    async (_, { rejectWithValue }) => {
        return getApiClient()
            .get('users/session/')
            .then(response => {
                return response.data;
            })
            .catch(error => {
                return rejectWithValue(error.message);
            });
    }
);

export const asyncLoginUser = createAsyncThunk<void, ILoginForm>(
    'users/loginUser',
    async (form: ILoginForm, { rejectWithValue }) => {
        const data = { ...form };
        return getApiClient()
            .post('users/session/auth/', data)
            .then(response => {
                localStorage.token = response.data.token;
            })
            .catch(error => {
                return rejectWithValue(error.message);
            });
    }
);

export const asyncFetchSessionUserScores = createAsyncThunk<IUserScore[], void>(
    'users/fetchSessionUserScores',
    async (_, { rejectWithValue }) => {
        return getApiClient()
            .get('users/session/scores/')
            .then(response => {
                return response.data;
            })
            .catch(error => {
                return rejectWithValue(error.message);
            });
    }
);

export const asyncFetchUserScores = createAsyncThunk<IUserScore[], number>(
    'users/fetchUserScores',
    async (userId, { rejectWithValue }) => {
        return getApiClient()
            .get(`users/${userId}/scores/`)
            .then(response => {
                return response.data;
            })
            .catch(error => {
                return rejectWithValue(error.message);
            });
    }
);

export const asyncFetchUsers = createAsyncThunk<IUser[], void>(
    'users/fetchUsers',
    async (_, { rejectWithValue }) => {
        return getApiClient()
            .get('users/')
            .then(response => {
                return response.data;
            })
            .catch(error => {
                return rejectWithValue(error.message);
            });
    }
);

export const asyncFetchScoreTypes = createAsyncThunk<IScoreType[], void>(
    'users/fetchScoreTypes',
    async (_, { rejectWithValue }) => {
        return getApiClient()
            .get('score-types/')
            .then(response => {
                return response.data;
            })
            .catch(error => {
                return rejectWithValue(error.message);
            });
    }
);

export const asyncCreateUserScore = createAsyncThunk<
    IScoreType[],
    { userId: number; userScores: INewUserScore[] }
>(
    'users/createUserScore',
    async (
        { userId, userScores }: { userId: number; userScores: INewUserScore[] },
        { rejectWithValue }
    ) => {
        const data = [...userScores];
        return getApiClient()
            .post(`users/${userId}/scores/`, data)
            .then(response => {
                return response.data;
            })
            .catch(error => {
                return rejectWithValue(error.message);
            });
    }
);
